import {
  DISPLAY_EVENTS_IN_DDL,
  HIDE_SQUAD_DIALOG,
  DISPLAY_SQUAD_DIALOG,
  DISPLAY_NEXT_MONTH,
  DISPLAY_PREVIOUS_MONTH,
  DISPLAY_TOURNAMENT_SQUADS,
  DISPLAY_SPECIFIC_MONTH,
  DISPLAY_SQUAD_DELETE_MODAL,
  HIDE_SQUAD_DELETE_DIALOG,
  DISPLAY_SQUAD_DELETE_CONFIRM_MODAL
} from './constants';

export const displaySquadDeleteModal = (error) => ({
  type: DISPLAY_SQUAD_DELETE_MODAL,
  payload: {
      error: error
  }
});

export const displaySquadDeleteConfirmModal = (warningMessage, error, choices, confirmation) => ({
  type: DISPLAY_SQUAD_DELETE_CONFIRM_MODAL,
  payload: {
      warningMessage: warningMessage,
      error: error,
      choices: choices,
      confirmation: confirmation
  }
});

export const displayEventsInDropDown = data => ({
  type: DISPLAY_EVENTS_IN_DDL,
  payload: data
});

export const hideSquadDialog = () => ({
  type: HIDE_SQUAD_DIALOG
});

export const hideSquadDeleteDialog = () => ({
  type: HIDE_SQUAD_DELETE_DIALOG
});

export const displaySquadDialog = title => ({
  type: DISPLAY_SQUAD_DIALOG,
  payload: title
});

export const displayNextMonth = () => ({
  type: DISPLAY_NEXT_MONTH
});

export const displayPreviousMonth = () => ({
  type: DISPLAY_PREVIOUS_MONTH
});

export const displaySpecificMonth = (month, year) => ({
  type: DISPLAY_SPECIFIC_MONTH,
  payload: {
    month: month,
    year: year
  }
});

export const displaySquads = data => ({
  type: DISPLAY_TOURNAMENT_SQUADS,
  payload: data
});



// WEBPACK FOOTER //
// ./src/features/tournament/squads/actionTypes.js